/**
 * Replaces `{{key}}` tokens in a template string with values from a map.
 *
 * @example
 * interpolateTemplateString("Hello {{name}}!", { "{{name}}": "World" })
 * // → "Hello World!"
 */
export function interpolateTemplateString(
  template: string | undefined,
  tokens: Record<`{{${string}}}`, string>,
): string {
  if (!template) return "";
  return Object.entries(tokens).reduce(
    (text, [token, value]) => text.replaceAll(token, value),
    template,
  );
}
